import React from "react";
import { Moon, Sun } from "lucide-react";

// Le libellé suit la ligne : « Remorque source » pour une remorque, « Camion source » sans remorque.
const END_OF_DAY_LOAD_DETAIL_ROWS = [
  { key: "initialDeliveryDate", label: "Date source" },
  { key: "sourceTruckLabel", labelKey: "sourceFieldLabel", label: "Camion source" },
  { key: "targetDeliveryDate", label: "Date cible" },
  { key: "targetTruckLabel", labelKey: "targetFieldLabel", label: "Camion cible" },
];

function EndOfDayLoadModeBadge({ label = "", mode = "next_day" }) {
  const isEvening = mode === "evening";
  const Icon = isEvening ? Moon : Sun;

  return (
    <span
      className={[
        "inline-flex max-w-full items-center gap-1 rounded-[4px] border px-2 py-0.5 text-[10px] font-black uppercase leading-tight tracking-[0.08em]",
        isEvening
          ? "border-slate-700 bg-slate-950 text-white"
          : "border-amber-300 bg-amber-100 text-amber-900",
      ].join(" ")}
    >
      <Icon className="h-3 w-3 shrink-0" aria-hidden="true" strokeWidth={2.3} />
      <span className="min-w-0 wrap-anywhere">{label}</span>
    </span>
  );
}

export function EndOfDayLoadHoverCardDetails({ details, layout = "grid" }) {
  if (!details) {
    return null;
  }

  const modeBadge = details.deliveryModeLabel ? (
    <EndOfDayLoadModeBadge
      label={details.deliveryModeLabel}
      mode={details.deliveryModeDisplayMode || details.deliveryMode}
    />
  ) : null;

  const detailRows = END_OF_DAY_LOAD_DETAIL_ROWS.map((row) => ({
    ...row,
    label: (row.labelKey && details[row.labelKey]) || row.label,
    value: details[row.key] || "—",
  }));

  const detailValueClassName = "min-w-0 wrap-anywhere text-[12px] font-semibold leading-[1.35] text-slate-900";

  if (layout === "inline") {
    return (
      <div className="grid gap-y-1.5">
        {modeBadge ? (
          <div className="min-w-0">
            {modeBadge}
          </div>
        ) : null}
        <div
          className="grid gap-x-3 gap-y-2"
          style={{ gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 9rem), 1fr))" }}
        >
          {detailRows.map((row) => (
            <div
              key={row.key}
              className="grid min-w-0 content-start gap-0.5"
            >
              <div className="text-[10px] font-semibold leading-[1.2] text-slate-500">{row.label}</div>
              <div className={detailValueClassName}>{row.value}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="grid gap-y-2">
      {modeBadge ? (
        <div className="min-w-0">
          {modeBadge}
        </div>
      ) : null}
      <div className="grid grid-cols-2 gap-x-4 gap-y-2">
        {detailRows.map((row) => (
          <div key={row.key} className="min-w-0 grid gap-0.5">
            <div className="text-[10px] font-semibold text-slate-500">{row.label}</div>
            <div className={detailValueClassName}>{row.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
